/*
* @Author: jack
* @Date:   2020-01-05 16:45:08
* @Last Modified by:   jack
* @Last Modified time: 2020-04-23 11:05:18
*/
import request from '@/utils/request'
import axios from 'axios'

export function share(data) {
  return request({
    url: 'api/wechat/share',
    method: 'post',
    data
  })
}
export function sharenum(data) {
  return request({
    url: 'api/acitvity/dati/user/sharenum',
    method: 'post',
    data
  })
}

export function getAcitvityInfo(data) {
  return axios.get('/json'+process.env.VUE_APP_PATH+'.json')
  // return request({
  //   //url: 'acitvity/index',
  //   url: 'json'+process.env.VUE_APP_PATH+'.json',
  //   method: 'get',
  //   data
  // })
}


